import React, {useState, useEffect, useContext} from 'react'
import { useTranslation } from "react-i18next";
import {setObjectByPath, GetAlertsComponent, validateConstantValues} from "./utils"
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RulesContext from "../../../../context/rules-context"
import TimeDeltaTextField from './Components/TimeDeltaTextField';


export function ActionDecisionBox (props) {
    const {t} = useTranslation()
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    let decisionOptions = useContext(RulesContext).boxes[node.node.type].settings.decision_options
    let optionsObject = decisionOptions.filter(option => option.value === node.node.properties.value)[0]

    return (
        <div>
            {!read_only ? 
                <div style={{display:"flex", alignItems: "center"}}>
                    <div 
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}} 
                        onClick={() => handleConfigurationOpen(node)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t((optionsObject || {description:""}).description)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {t(node.node.properties.reason_description)} 
                            </div>
                        </div>
                        {(node.node.alerts || []).length > 0 ?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null}  
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div 
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}} 
                        onClick={() => handleConfigurationOpen(node)}
                    >
                        <div style={{display: "flex", flexDirection: "column", margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                                {t((optionsObject || {description:""}).description)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                                {t(node.node.properties.reason_description)}
                            </div>
                        </div>     
                    </div>
                </div>
            }
        </div>
    )
}

export function ActionDecisionConfiguration(props){
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleNodeChange} = props
    let {handleConfigurationClose} = props

    let decisionOptions = useContext(RulesContext).boxes[node.node.type].settings.decision_options
    const customExpirationEnabled = useContext(RulesContext).boxes[node.node.type].settings.custom_expiration_enabled ?? false;

    const [nodeState, setNodeState] = useState(node)

    useEffect(()=>{
        setNodeState(node)
    },[node])

    const handleNodeStateChange = (obj_key,value) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,obj_key,value)
        if (obj_key === 'properties.value' && value !== 'in_manual_analysis' && new_node.node.properties.custom_expiration) {
            new_node.node.properties.custom_expiration = undefined;
        }
        setNodeState(new_node)
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(nodeState)
    }

    const validateAllValues = () => {
        return (
            (nodeState.node.properties.value && nodeState.node.properties.value.length >0) &&
            (nodeState.node.properties.reason && nodeState.node.properties.reason.length >0) &&
            (nodeState.node.properties.reason_description && nodeState.node.properties.reason_description.length >0)
        )
    }


    return(
        <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column"}}>
            <div style={{display: "flex"}}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "14px", display:"flex", margin:"auto 5px"}}/>
                </Tooltip>
            </div>
            <div className="internalCardContainer" style={{display:"flex", flexDirection: "column"}}>
            <TextField 
                label={t("Decisão")}
                style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                className="filterTextbox" 
                size="small" fullWidth 
                value={nodeState.node.properties.value}
                onChange={(e) => handleNodeStateChange("properties.value", e.target.value)}
                InputProps={{
                    readOnly: read_only
                  }}
                select
            >
                {decisionOptions.map((option, index) => (
                    <MenuItem key={index} value={option.value}><em className="normalText">{t(option.description)}</em></MenuItem>
                ))}
            </TextField>
            <TextField 
                label={t("Descrição da Razão")}
                style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                className="filterTextbox" 
                size="small" fullWidth 
                value={nodeState.node.properties.reason_description}
                onChange={(e) => handleNodeStateChange("properties.reason_description", e.target.value)}
                InputProps={{
                    readOnly: read_only
                  }}
            />   
            <TextField 
                label={t("Enumerador")}
                style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                className="filterTextbox" 
                size="small" fullWidth 
                value={nodeState.node.properties.reason}
                onChange={(e) => handleNodeStateChange("properties.reason", e.target.value)}
                InputProps={{
                    readOnly: read_only
                  }}
            />
            {customExpirationEnabled && nodeState.node.properties.value === 'in_manual_analysis' &&
                <TimeDeltaTextField
                    value={nodeState.node.properties.custom_expiration}
                    error={nodeState.node.properties.custom_expiration ? !validateConstantValues("timedelta", nodeState.node.properties.custom_expiration) : false}
                    valueChangeFunction={(value) => handleNodeStateChange("properties.custom_expiration", value)}
                    label={t("Expiração Personalizada")}
                    read_only={read_only}
                />
            }   
            </div>
                <div style={{display:"flex", margin: "auto auto 5px auto"}}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{width:"120px"}}
                        onClick={handleConfigurationClose}
                    >
                        {read_only ? "X" : t("discard")}
                    </div>
                    {!read_only && 
                    <div
                        className={
                            validateAllValues()
                            ?
                            ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                            :
                            ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                        style={{width:"120px"}}
                        onClick={validateAllValues() ? handleSave : null}
                    >
                        {t("save")}
                    </div>}   
                </div>
        </div>
    )
}

export class ActionDecisionBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    

    validate(node){
        let put_error = false
        let alerts = []

        let decisionOptions = this.rulesContext.boxes[node.node.type].settings.decision_options
        const isCustomExpirationEnabled = this.rulesContext.boxes[node.node.type].settings.custom_expiration_enabled ?? false;
        
        let values_list = decisionOptions.reduce((acc, option) => {
            acc.push(option.value)
            return acc
        },[])

        if((node.node.children || []).length !== 0){
            put_error = true
            alerts.push("O nó de Decisão não pode ter filhos")
        }

        if (!values_list.includes(node.node.properties.value)){
            put_error = true
            alerts.push("Clique no nó desta Decisão, abra a configuração e escolha uma decisão válida")
        }

        if ((node.node.properties.reason||"").length === 0){
            put_error = true
            alerts.push("Clique no nó desta Decisão, abra a configuração e escreva uma razão")
        }

        if ((node.node.properties.reason_description||"").length === 0){
            put_error = true
            alerts.push("Clique no nó desta Decisão, abra a configuração e escreva uma descrição para a razão")
        }

        if (!isCustomExpirationEnabled && (node.node.properties.custom_expiration || "").length > 0) {
            put_error = true
            alerts.push("O campo de Expiração Personalizada não está habilitado para esta regra")
        } else if ((node.node.properties.custom_expiration || '').length > 0) {
            const customExpiration = node.node.properties.custom_expiration;

            if (node.node.properties.value !== 'in_manual_analysis') {
                put_error = true
                alerts.push("O campo de Expiração Personalizada só pode ser fornecido para a decisão de Análise Manual")
            }

            if (!validateConstantValues("timedelta", customExpiration)) {
                put_error = true
                alerts.push("O campo de Expiração Personalizada deve ser um período de tempo válido quando fornecido")
            }
        }

        if (node.parentNode != null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return "void"
    }
}